import { ICardModifierData } from './ICardModifierData';
import { CardType } from './CardType';

export const DEFAULT_CARD_WIDTH: number = 112;
export const DEFAULT_CARD_HEIGHT: number = 160;

export interface ICardData {
    id?: string;
    type: CardType;
    random?: boolean;
    value?: number;
    x?: number;
    y?: number;
    depth?: number;
    angle?: number;
    modifiers?: ICardModifierData[];
    faceUp?: boolean;
    sequence?: number;
    suit?: number;
}
